<template>
  <div>
    <div class="admin-header">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="white">Order: {{order.firstname}} {{order.lastname}} - {{createdFmtNoTime}}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="processing">
      <div class="row space-loader d-flex align-items-center justify-content-center">
        <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <div class="container section-padding" v-else>
      <div class="row">
        <div class="col-lg-12">
          <h2 class="space-bottom">Order Info:</h2>
        </div>
        <div class="col-lg-12 space-bottom-small">
          <label style="font-weight:600" for="status">Order Status:</label>
          <select class="form-control" id="status" v-model="order.status">
            <option value="pending">Pending</option>
            <option value="fulfilled">Fulfilled</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
        <div class="col-lg-12">
          <div>
            <label style="font-weight:600" for="status">Order Number:</label>
            <p>#{{order.id}}</p>
          </div>
          <div>
            <label style="font-weight:600" for="status">Ordered:</label>
            <p>{{createdFmt}}</p>
          </div>
        </div>
        <div class="col-lg-12 space-top">
          <h2 class="space-bottom">Contact Info:</h2>
        </div>
        <div class="col-lg-12">
          <div>
            <label style="font-weight:600" for="status">Name:</label>
            <p>{{order.firstname}} {{order.lastname}}</p>
          </div>
          <div>
            <label style="font-weight:600" for="status">Email:</label>
            <p>{{order.email}}</p>
          </div>
          <div>
            <label style="font-weight:600" for="status">Phone:</label>
            <p>{{order.phone}}</p>
          </div>
        </div>

        <div class="col-lg-12 space-top">
          <h2 class="space-bottom">Shipping Info:</h2>
        </div>

        <div class="col-lg-12 space-bottom-small">
          <label style="font-weight:600" for="method">Shipping Method:</label>
          <select class="form-control" id="method" v-model="order.shipping_type">
            <option value="pickup">Pickup</option>
            <option value="delivery">Delivery</option>
            <option value="shipment">Shipment</option>
          </select>

        </div>
        <div class="col-lg-12 space-bottom-small">
          <label style="font-weight:600" for="method">Shipping Address:</label>
          <input v-model="order.shipping_address" type="text" class="form-control" id="shipping_address"
            placeholder="Shipping Address" />
        </div>
        <div class="col-lg-12">
          <label style="font-weight:600" for="method">Shipping Cost:</label>
          <input v-model="order.shipping_cost" type="number" step="0.01" class="form-control" id="shipping_cost"
            placeholder="Shipping Cost" />
        </div>






        <div style="margin-top:3rem" class="col-lg-12 space-top" v-if="includedProducts.length != 0">
          <h2>Products:</h2>
          <OrderProductCard v-for="(product, productIndex) in includedProducts" :key="productIndex"
            v-bind:product="product" />
        </div>


        <div style="margin-top:3rem" class="col-lg-12 space-top" v-if="removedProducts.length != 0">
          <h2>Removed Products</h2>
          <OrderProductCard v-for="(product, productIndex) in removedProducts" :key="productIndex"
            v-bind:product="product" />
        </div>

        <div class="col-lg-12 border-hop">
          <h2 class="space-bottom">Totals:</h2>
          <div>
            <label style="font-weight:600">Number Of Items:</label>
            <p>{{includedProducts.length}}</p>
          </div>
          <div>
            <label style="font-weight:600">Item Total:</label>
            <p>{{includedTotal}}</p>
          </div>
          <div>
            <label style="font-weight:600">Shipping Total:</label>
            <p>{{shippingTotal}}</p>
          </div>
          <div>
            <label style="font-weight:600">Grand Total:</label>
            <p>{{totalWithShipping}}</p>
          </div>
        </div>
        <div class="col-lg-12 space-top">
          <div v-if="errorMessage != ''" style="color: red">{{errorMessage}}</div>
          <button class="btn btn-primary" v-on:click="updateOrder">Save Changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import api from "../../api/api";
  import OrderProductCard from "@/components/Admin/OrderProductCard.vue";

  export default {
    components: {
      OrderProductCard,
    },
    data: function () {
      return {
        order: {
          id: "",
          created: "",
          status: "",
          firstname: "",
          lastname: "",
          email: "",
          phone: "",
          shipping_type: "",
          shipping_address: "",
          shipping_cost: 0,
          products: [],
        },
        processing: false,
        errorMessage: "",
        dirty: false,
      };
    },
    mounted() {
      this.loadOrder();
    },
    computed: {
      createdFmtNoTime() {
        return moment(this.order.created).format("MMMM DD, YYYY");
      },
      createdFmt() {
        return moment(this.order.created).format("h:mm a MMMM DD, YYYY");
      },
      includedTotal() {
        var total = 0;
        this.includedProducts.forEach((product) => (total += product.price));
        return total.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
      includedProducts() {
        return this.order.products.filter(
          (product) => product.status == "included"
        );
      },
      removedProducts() {
        return this.order.products.filter(
          (product) => product.status == "removed"
        );
      },
      shippingTotal() {
        return parseFloat(this.order.shipping_cost).toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
      totalWithShipping() {
        var total = 0;
        this.includedProducts.forEach((product) => (total += product.price));
        total += parseFloat(this.order.shipping_cost);
        return total.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        });
      },
    },
    methods: {
      updateOrder() {
        this.processing = true;
        this.errorMessage = false;
        var promises = [];
        promises.push(
          api
            .updateOrder(
              this.order.id,
              this.order.status,
              parseFloat(this.order.shipping_cost),
              this.order.shipping_address,
              this.order.shipping_type
            )
            .catch((err) => {
              this.errorMessage += err;
            })
        );
        this.order.products.forEach((product) => {
          promises.push(
            api
              .updateOrderProduct(this.order.id, product.id, product.status)
              .catch((err) => {
                this.errorMessage += err;
              })
          );
        });
        Promise.all(promises)
          .finally(() => {
            this.processing = false;
            this.$router.push("/admin/orders");
          })
      },
      loadOrder() {
        this.processing = true;
        api
          .getOrder(this.$route.params.id)
          .then((res) => {
            this.order = res;
          })
          // .catch((err) => {
          //   console.log(err);
          // })
          .finally(() => {
            this.processing = false;
          });
      },
    },
  };
</script>